import {Switch} from '@wandb/weave/components';
import * as React from 'react';

import {LabeledOptionBlock as LabeledOption} from '../elements/LabeledOptionBlock';
import ProjectFieldSelector from '../ProjectFieldSelector';
import {type PanelGroupingOptionsProps} from './types';

export function MultiRunAggOptions(props: PanelGroupingOptionsProps) {
  // show user options to aggregate over runs
  const {config, updateConfig, pageQuery, disabled} = props;
  return (
    <>
      <LabeledOption
        label="Group runs"
        helpText="Aggregate over runs"
        option={
          <Switch.Root
            data-test={`checkbox-aggregate`}
            size="medium"
            name="aggregate"
            disabled={disabled}
            checked={config.aggregate}
            onCheckedChange={isChecked => updateConfig({aggregate: isChecked})}>
            <Switch.Thumb size="medium" checked={config.aggregate ?? false} />
          </Switch.Root>
        }
      />
      {config.aggregate && (
        <LabeledOption
          label="Group by"
          helpText="Group by a run attribute"
          option={
            <ProjectFieldSelector
              className={'groupby-picker'}
              disabled={!props.config.aggregate}
              query={pageQuery}
              selection
              columns={['config']}
              defaultKeys={['config:None']}
              value={`config:${config.groupBy ?? 'None'}`}
              multi={false}
              searchByKeyAndText
              setValue={value =>
                updateConfig({
                  groupBy: value.split(':')[1],
                })
              }
            />
          }
        />
      )}
    </>
  );
}

export function SingleRunAggOptions(props: PanelGroupingOptionsProps) {
  // user will always aggregate over metrics
  // if that's not possible show warning
  const {config} = props;
  return (
    <>
      {(config.metrics == null || config.metrics.length <= 1) && (
        <>
          <p>Select multiple metrics to enable grouping</p>
        </>
      )}
    </>
  );
}
